import * as React from 'react'
import './Promocode.css'
import { PromocodeConfig } from '../../configs/stream-entities'
import PromocodeList from './promocode-list/PromocodeList'
import PromocodeDetail from './promocode-detail/PromocodeDetail'

class PromocodeState {
    public selectedId: string = ''
}

class Promocode extends React.Component<any, PromocodeState> {
    constructor(props: any) {
        super(props)
        this.state = new PromocodeState()
        this.showDetails = this.showDetails.bind(this)
    }

    public render() {
        return (<div className="Promocode">
            <PromocodeList onItemSelected={this.showDetails} isMultiple={true} defaultValue={""} />
            <PromocodeDetail promocodeId={this.state.selectedId} />
        </div>)
    }

    private showDetails(promocode: PromocodeConfig) {
        this.setState({ selectedId: promocode.id })
    }
}

export default Promocode


// WEBPACK FOOTER //
// ./src/components/promocode/Promocode.tsx